import { config } from '@uhg-abyss/web/tools/config';
export const ReviewReasonCode = {
  CDFWA: 'FWA',
  CDGCFromPriorCycle: 'GCFromPriorCycle',
  CDNDA: 'NDA',
  CDOON: 'OON',
  CDGC: 'GC',
};
// Maximum number of TINs allowed for selection
export const tinLimit = 50;
export const unpublished = 'Unpublished';
export const unPublishedDiscription =
  'Open, edit and republish to add a screen back in to the flow.';
export const noUnpublished = 'No unpublished yet';
export const onBoardingPageInfo = {
  Title: 'Onboarding',
};
export const includeBaseCss = false;
export const suppressDollar = config('SUPPRESS_DOLLAR');
export const replaceDollarValues = (cardsData) => {
  return cardsData.map((card) => {
    // Check if total contains a dollar sign and replace with dash
    if (card.total && typeof card.total === 'string' && card.total.includes('$')) {
      return {
        ...card,
        total: '-',
      };
    }

    // Also check cardValues array for dollar signs and replace
    if (card.cardValues && Array.isArray(card.cardValues)) {
      const updatedCardValues = card.cardValues.map((cardValue) => {
        if (
          cardValue.value &&
          typeof cardValue.value === 'string' &&
          cardValue.value.includes('$')
        ) {
          return {
            ...cardValue,
            value: '-',
          };
        }
        return cardValue;
      });

      return {
        ...card,
        cardValues: updatedCardValues,
      };
    }

    return card;
  });
};

export const SOS_PROGRAMS = new Set([
  'Site of Service Colonoscopies',
  'Site of Service Surgeries',
  'Site of Service Office',
  'Site of Service Radiology',
]);
export const enableSOSUpdate = true;
export const enableAiIcon = true;

export const ANALYTICS_EVENTS = {
  RADIO_BUTTON: 'radio button',
  PAGE_FILTER: 'page filter',
  KNOWLEDGE_CENTER: 'knowledge center',
  CARD_DROPDOWN: 'card dropdown',
  SECTION_FILTER: 'section filter',
  LINK_CLICKS: 'link clicks',
  TABLE_EXPORT: 'table export',
  PAGE_CTA_LINK_CLICKS: 'page cta link clicks',
  CHECKBOX: 'checkbox',
  MODAL_CTA_CLICKS: 'modal cta clicks',
  TAB_CLICKS: 'tab clicks',
  TABLE: 'table',
  APPLY_FILTERS: 'apply filters',
  INTERACTION: 'interaction',
  RESET_FILTER: 'Reset Filter',
  PRINT_BUTTON_CLICK: 'printButtonClick',
  PAGE_LOAD: 'pageLoad',
  EXIT_CLICK: 'exit click',
  JOB_COMPLETED: 'jobComplete',
  JOB_START: 'jobStart',
  VIEW_TAX_ID_DETAILS: 'view tax ID details',
  MODAL_VIEW: 'modal view',
  MODAL_CLOSE: 'modal close',
  PRINT_JOB_NAME: 'print',
  GLOBAL_FILTER_JOB_START: 'globalFilterJobStart',
  GLOBAL_FILTER_SELECTION: 'globalFilterSelection',
  GLOBAL_FILTERS_CONTEXT: 'Global Filters',
  TABLE_PAGINATION: 'Pagination',
  TABLE_SORT: 'Sort',
  TABLE_SEARCH: 'Search',
  HEATMAP: 'heatmap',
  SEARCH: 'Search',
};

export const MODAL_NAMES = {
  KNOWLEDGE_CENTER: 'Knowledge Center',
  COMPARE_LOBS: 'Compare Lines of Business',
  CONTRACT_ID_SELECTION: 'Contract ID Selection',
};

export const FILTER_EVENT_KEYS = {
  TIME_PERIOD: 'timeperiod',
  lob: 'lob',
  tin: 'tin',
  contractId: 'contractid',
};

export const DROPDOWN_NAMES = {
  CLAIMS_YIELD: 'Claim Yield',
};

export const HOME_PAGE_REPORT_CARD = {
  AFFORDABILITY_DRIVERS: 'Affordability Drivers',
  CONTRACT_INTELLIGENCE_INDICATORS: 'Contract Intelligence Indicators',
  OPERATIONS_REPORTING: 'Operations Reporting',
  RED_FLAG_REPORT: 'Red Flag Report',
  GENESIS: 'Genesis',
  PROVIDER_NEGOTIATION_BRIEFING: 'Provider Negotiation Briefing',
  PROVIDER_EXPERIENCE_MEASUREMENT: 'Provider Experience Measurement',
  TIERING_CHANGE_REPORT: 'Tiering Change Report',
  PROVIDER_SERVICE_MODEL_SCORECARD: 'Provider Service Model Scorecard',
  IMPACT: 'IMPACT',
};

export const HOMEPAGE_SEARCH_TABS = {
  HEALTH_SYSTEM: 'HEALTH_SYSTEM',
  TAX_ID: 'TAX_ID',
  GEO_SEGMENTATION: 'GEO_SEGMENTATION',
  ASSOCIATED_SEARCH_STRING: {
    HEALTH_SYSTEM: 'Parent Entity Search',
    TAX_ID: 'Tax ID Search',
    GEO_SEGMENTATION: 'Geo Segmentation Search',
    SEARCH: 'Search',
  },
};

export const PAGE_NAME = {
  HOME_PAGE: 'Home Page',
};
